module.exports = __webpack_public_path__ + "img/collection.d2508159.svg";